export const STRING_MENU = {
  DASHBOARD: "Dashboard",
  SETTING: "Setting",
  PARENT_MODULE: "Parent Module",
  PROFILE: "Thông tin tài khoản",
  CHANGE_PASSWORD: "Đổi mật khẩu",
  HUMAN_RESOURCE_MANAGEMENT: "Quản lý nhân sự (HRM)",
};

export const STRING_SUB_MENU = {
  CHILDREN_1: "Children 1",
  CHILDREN_2: "Children 2",
  ATTENDANCE_MANAGEMENT: "Quản lý chấm công",
  PAYROLL_MANAGEMENT: "Quản Lý Chấm Công & Lương",
  ATTENDANCE_PERSONAL: "Chấm công của tôi",
};
